<template>
    <form :action="route" method="POST" class="rdv-w-layout__form" @submit.prevent="submitForm">
        <input type="hidden" name="_token" :value="csrfToken">
        <input type="hidden" name="honeypot" id="honeypot"  value="" >
        <div v-show="step === 'APPOINTMENT_AGENDA'" class="rdv-w-layout-inner--appointment toggle-form-inner toggle-form-init-visible">
            <h2 class="wellcoming__form-title">Prise de rendez-vous</h2>
            <p class="intro">Sélectionnez votre créneau de rendez-vous avec l'un de nos experts.</p>
            <div class="rounded-grey-wrapper">
                <div class="text-left">
                    <div class="h-70">
                        <div class="form-title--content">Votre lieu de rendez-vous :</div>
                        <small v-if="v$.typeAppointment.$error"  class="ck-error-message">{{ v$.typeAppointment.$errors[0].$message }}</small>
                    </div>
                    <input type="hidden" name="appointment" value="appointment1" />
                    <input type="hidden" name="system_user_id" v-model="system_user_id" />

                    <div class="form-radio_pointer white-bg form-radio_pointer--separated">
                        <input type="radio" id="rdv-en_magasin" name="typeAppointment" value="in-store" v-model="v$.typeAppointment.$model" />
                        <label for="rdv-en_magasin">En magasin</label>
                    </div>
                    <div class="form-radio_pointer white-bg form-radio_pointer--separated">
                        <input type="radio" id="rdv-a_distance" name="typeAppointment" value="in-distance" v-model="v$.typeAppointment.$model" />
                        <label for="rdv-a_distance">A distance</label>
                        <span class="pointer"></span>
                    </div>
                </div>
                <div class="h-70">
                    <div class="form-title--content">Sélectionnez votre créneau de rendez-vous :</div>
                    <small v-if="v$.timeSlot.$error" class="ck-error-message">{{ v$.timeSlot.$errors[0].$message }}</small>
                </div>
                <div v-show="slotsAvailable.length > 0" class="timeslots timeslots-calendar" ref="timeslots">
                    <div v-for="day in slotsAvailable" :key="day.date" class="timeslots__item">
                        <p class="timeslots__title">{{ day.date }}</p>
                        <div v-if="day.slots.length > 0" class="timeslots__inner">
                            <div v-for="slot in day.slots" :key="slot.id" class="timeslots__slot">
                                <input @click="selectTime(slot)" :disabled="slot.disabled" type="radio" :id="slot.id" name="timeslot" :value="slot.value" v-model="timeSlot" />
                                <label :for="slot.id">{{ slot.text }}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="isLoading" class="timeslots__no-slots">
                    <p>Chargement des créneaux en cours</p>
                </div>
                <div v-else-if="slotsAvailable.length === 0" class="timeslots__no-slots">
                    <p>Aucun rendez-vous n'est disponible prochainement, laissez-nous vos coordonnées pour être rappelé.</p>
                </div>
                <p class="custom-link">
                    <span class="custom-link__label">Vous voulez un rendez-vous plus tard ? </span>
                    <a href="#" class="custom-link__link" @click.prevent="onCallbackLinkClick">
                            <span>
                                Se faire rappeler
                            </span>
                    </a>
                </p>
            </div>
            <div class="rdv-w-layout__sticky-btn">
                <button type="button" ref="validateBtn" @click="validateSlot" class="btn submit-btn toggle-form-action">Valider</button>
            </div>
        </div>


        <collapse-transition :duration="500">
            <div v-show="step === 'APPOINTMENT_INFO'" class="rdv-w-layout-inner--appointment toggle-form-inner">
                <h2 class="wellcoming__form-title">Complétez vos informations</h2>
                <p class="required-text">*Champs obligatoires</p>
                <div class="rounded-grey-wrapper">
                    <div class="form-grid">
                        <div class="form-grid__fields">
                            <p class="form-title form-title--strong">Vos coordonnées</p>
                            <div class="form-radio_pointer white-bg">
                                <input type="radio" id="info-civility-madame" name="civility" value="madame" v-model="civility" />
                                <label for="info-civility-madame">Madame</label>
                                <input type="radio" id="info-civility-monsieur" name="civility" value="monsieur" v-model="civility" />
                                <label for="info-civility-monsieur">Monsieur</label>
                                <span class="pointer"></span>
                            </div>
                            <div class="form-row">
                                <div class="form-group">
                                    <label for="info-firstName" class="sr-only">Votre prénom</label>
                                    <input :class="{'input-error': v$.firstName.$error}" type="text" id="info-firstName" name="firstName" :placeholder="'Votre prénom *'" required v-model="v$.firstName.$model" aria-describedby="info-firstName__errors" />
                                    <div id="info-firstName__errors">
                                        <small v-if="v$.firstName.$error" class="ck-error-message">{{ v$.firstName.$errors[0].$message }}</small>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="info-lastName" class="sr-only">Votre nom</label>
                                    <input :class="{'input-error': v$.lastName.$error}" type="text" id="info-lastName" name="lastName" :placeholder="'Votre nom *'" required v-model="v$.lastName.$model" aria-describedby="info-lastName__errors" />
                                    <div id="info-lastName__errors">
                                        <small v-if="v$.lastName.$error" class="ck-error-message">{{ v$.lastName.$errors[0].$message }}</small>
                                    </div>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-group">
                                    <label for="info-email" class="sr-only">Votre email</label>
                                    <input :class="{'input-error': v$.email.$error}" type="email" id="info-email" name="email" :placeholder="'Votre email *'" required v-model="v$.email.$model" aria-describedby="info-email__errors" />
                                    <div id="info-email__errors">
                                        <small v-if="v$.email.$error" class="ck-error-message">{{ v$.email.$errors[0].$message }}</small>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="contact-mobilePhone" class="sr-only">Votre téléphone</label>
                                    <IntlTelInputCustom
                                        v-model="mobilePhone"
                                        :id="'contact-mobilePhone'"
                                        :aria-describedby="'info-mobilePhone__errors'"
                                        :error="v$.mobilePhone.$error"
                                        @changeNumber="mobilePhone = $event"
                                        @changeValidity="v => phoneValid = v"
                                        @blur="v$.mobilePhone.$touch()"
                                    />
                                    <div id="info-mobile__errors">
                                        <small v-if="v$.mobilePhone.$error" class="ck-error-message">{{ v$.mobilePhone.$errors[0].$message }}</small>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <p class="commercial-info">J’accepte d’être contacté(e) pour être informé(e) des
                                    nouveautés et des bons plans :</p>
                                <div class="form-item-row form-checkbox-communication form-checkbox_pointer">
                                    <div class="form-item">
                                        <input
                                            type="checkbox"
                                            id="infos-communication-sms"
                                            name="isSmsAllowed"
                                            v-model="isSmsAllowed"
                                        />
                                        <label class="communication-calendar" for="infos-communication-sms">Par SMS</label>
                                    </div>
                                    <div class="form-item">
                                        <input
                                            type="checkbox"
                                            id="infos-communication-email"
                                            name="isEmailAllowed"
                                            v-model="isEmailAllowed"
                                        />
                                        <label class="communication-calendar" for="infos-communication-email">Par Email</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-grid__store">
                            <p class="form-title form-title--strong">Votre magasin</p>
                            <div class="store-card">
                                <div class="store-card__left" v-if="store">
                                    <p class="store-card__title">{{ stores[store]?.name }}</p>
                                    <p class="store-card__address">
                                        {{ stores[store]?.streetAddress }}<br/>
                                        {{ stores[store]?.postalCode }}  {{ stores[store]?.locality }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rdv-w-layout__sticky-btn">
                    <button @click="v$.$touch()" type="submit" class="btn submit-btn">Valider</button>
                </div>
                <p class="form-info">
                    Les données recueillies par le biais du formulaire ci-dessus permettront à la société nom de la société CKBF (488 052 150 RCS Bobigny) qui anime le réseau de distribution Cake Kitchen (ci-après « l’Enseigne »), et au franchisé sélectionné à la page précédente (ci-après le « Magasin ») de fixer un rendez-vous entre vous et le Magasin et si vous avez coché la case « par SMS » et/ou « par Email », de vous envoyer, selon le(s) moyen(s) au(x)quel(s) vous avez consenti (courriel ou sms), des informations et offres promotionnelles. Elles permettront également de vous contacter, afin de réaliser des enquêtes, à la suite de ce rendez-vous et éventuellement à vous inviter à partage votre avis. Elles permettront également de réaliser différentes statistiques.
                </p>

                <p class="form-info">
                    Vous disposez de droits d’accès, de rectification, de limitation, de portabilité, d’opposition et de suppression de vos données personnelles que vous pouvez exercer en cliquant <a href="https://www.cakekitchen.fr/exercice-de-droit" target="_blank" >ici</a>.
                </p>
                <p class="form-info">
                    <u><a href="https://www.cakekitchen.fr/mentions-rdv"  target="_blank">En Savoir plus</a></u>
                </p>
                <p class="form-info">
                    Tout consommateur qui ne souhaite pas faire l’objet d’une prospection commerciale par voie téléphonique peut s’inscrire gratuitement sur la liste d’opposition au démarchage téléphonique à l’adresse suivante : <a href="https://www.bloctel.gouv.fr" target="_blank">https://www.bloctel.gouv.fr</a>
                </p>
            </div>

        </collapse-transition>
    </form>
</template>
<script>
import { useVuelidate } from '@vuelidate/core';
import { required, helpers } from '@vuelidate/validators';
import {
    isValidFirstName,
    isValidLastName,
    isValidEmail,
    isValidPhoneNumber,
    hasNoAccents,
    transformTimeRange, transformTime,
} from '../../views/modules/wellcoming/scripts/helpers/helpers';
import collapseTransition from '@ivanv/vue-collapse-transition';
import axios from "axios";
import IntlTelInputCustom from "../components/IntlTelInputCustom.vue";

export default {
    name: 'Calendar',
    components: {
        IntlTelInputCustom,
        'collapse-transition': collapseTransition,
    },
    props: {
        step: String,
        stores: Object,
        route: {
            type: String,
            default : '#'
        },
        csrfToken: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            isLoading: true,
            slotsAvailable: [],
            system_user_id: null,
            timeSlot: null,
            civility: 'madame',
            firstName: null,
            lastName: null,
            email: null,
            mobilePhone: null,
            isSmsAllowed: 0,
            isEmailAllowed: 0,
            typeAppointment: null,
            v$: null,
            hasScrolledToValidate: false, // flag pour n’exécuter le scroll qu’une fois
            refreshSteps: ['APPOINTMENT_AGENDA', 'APPOINTMENT_INFO'],
            store : null,
            available_slot_id : null,
            nsInstance: null,
            phoneValid : false
        }
    },
    validations () {
        return {
            typeAppointment: {
                required: helpers.withMessage('Veuillez sélectionner un lieu de rendez-vous', required)
            },
            timeSlot: {
                required: helpers.withMessage('Veuillez sélectionner un créneau horaire', required)
            },
            civility: {
                required: helpers.withMessage('Veuillez sélectionner une civilité', required)
            },
            firstName: {
                required: helpers.withMessage('Le champ prénom est obligatoire', required),
                isValid: helpers.withMessage('Veuillez saisir un prénom valide', isValidFirstName),
            },
            lastName: {
                required: helpers.withMessage('Le champ nom est obligatoire', required),
                hasNoAccents: helpers.withMessage('Les accents ne sont pas autorisés dans le nom', hasNoAccents),
                isValid: helpers.withMessage('Veuillez saisir un nom valide', isValidLastName),
            },
            email: {
                required: helpers.withMessage('Le champ email est obligatoire', required),
                isValidEmail: helpers.withMessage('Veuillez saisir un email valide', isValidEmail),
            },
            mobilePhone: {
                required: helpers.withMessage('Le champ téléphone est obligatoire', required),
                isValidPhoneNumber: helpers.withMessage('Veuillez saisir un numéro de téléphone valide', this.isValidMobilePhone),
            },
        }
    },
    mounted() {
        const section = this.$el.closest("section.step-item");

        if (!section) return;

        const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
                if (
                    mutation.attributeName === "class" &&
                    section.classList.contains("step-current")
                ) {
                    if(this.refreshSteps.includes(this.step)){
                        this.goBackToAgenda();
                    }
                }
            }
        });

        observer.observe(section, { attributes: true });

        this.radioEls = Array.from(
            document.querySelectorAll("input[name='store_code']")
        );
        // on initialise la valeur si un radio est déjà coché
        const initial = document.querySelector("input[name='store_code']:checked");
        if (initial) this.store = initial.value;

        // on bind la méthode
        this.onStoreChange = this.onStoreChange.bind(this);
        // on écoute l'événement change sur chacun
        this.radioEls.forEach(el => {
            el.addEventListener('change', this.onStoreChange);
        });

    },
    beforeUnmount() {
        // on détache proprement les écouteurs
        this.radioEls.forEach(el => {
            el.removeEventListener('change', this.onStoreChange);
        });
    },
    created() {
        this.v$ = useVuelidate();
    },
    watch : {
        firstName () {
        },
        typeAppointment () {
        },
        step(newStep) {
            if (newStep === 'APPOINTMENT_AGENDA') {
                //si on change de step, on rafraichit les slots
                this.goBackToAgenda()
                // si on a déjà chargé des créneaux, on init/show
                if (this.slotsAvailable.length > 0) {
                    this.initNiceScroll();
                }
            } else {
                // dès qu’on sort de l’agenda, on cache la scrollbar
                if (this.nsInstance) {
                    this.nsInstance.remove();
                    this.nsInstance = null;
                }
            }
        },
        slotsAvailable(slots) {
            if (this.step === 'APPOINTMENT_AGENDA' && slots.length > 0) {
                this.initNiceScroll();
            }
        }
    },
    methods: {
        isValidMobilePhone(){
            return this.phoneValid;
        },
        validateAgendaStep() {
            this.v$.typeAppointment.$touch();
            this.v$.timeSlot.$touch();

            // collecte des messages (Vuelidate)
            if (this.v$.typeAppointment.$invalid) {
                return false;
            }
            if (this.v$.timeSlot.$invalid) {
                return false
            }

            return true;
        },
        validateSlot(){
            if (!this.validateAgendaStep()) {
                this.$nextTick(() => {
                    document.querySelector('.ck-error-message')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                });
                return; // ne pas changer d’étape
            }
            this.$emit('go-to-step', 'APPOINTMENT_INFO');
            this.slotsAvailable = [];
            this.addDataLayer('appointment_infos')
        },
        addDataLayer(step){
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
                "event": "page_view",
                "chapter1": "",
                "chapter2": "",
                "chapter3": "",
                "step": step,
            });
            console.info("[GTM] Following data was added to dataLayer:")
            console.table(dataLayer)
        },
        goBackToAgenda(){
            this.$emit('go-to-step', 'APPOINTMENT_AGENDA');
            this.onBecomingVisible();
        },
        getSelectedStoreCode () {
            const storeCodeInput = document.querySelector("input[name='store_code']:checked");

            if (!storeCodeInput) return null;
            this.store = storeCodeInput.value;

            return storeCodeInput.value;
        },
        selectTime(slot) {
            this.system_user_id = slot.system_user_id;
            this.available_slot_id = slot.available_slot_id;
            this.scrollOnceToValidate();
        },
        scrollOnceToValidate(){
            if (this.hasScrolledToValidate) return;
            this.hasScrolledToValidate = true;
            this.$nextTick(() => {
                this.$refs.validateBtn.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            });
        },
        onBecomingVisible() {
            this.addDataLayer("agenda");
            this.getAvailableSlots();
        },
        convertApiResponseToSlots (slots_available) {
            if (!slots_available) return [];

            const daySlots = [];

            let dayIndex = 0;

            for (let [dayKey, hourSlots] of Object.entries(slots_available)) {
                const daySlot = {date: dayKey, slots: []}

                let hourIndex = 0;
                for (let [hourKey, hourSlot] of Object.entries(hourSlots)) {
                    const id = `timeslot-${dayIndex}-${hourIndex}`;
                    const text = transformTimeRange(hourKey);
                    const disabled = hourSlot ? false : true;
                    const value = hourSlot ? hourSlot.from_timestamp : null;
                    const system_user_id = hourSlot ? hourSlot.system_user_id : null;
                    const available_slot_id = hourSlot ? hourSlot.available_slot_id : null;

                    daySlot.slots.push({
                        id,
                        text,
                        disabled,
                        value,
                        system_user_id,
                        available_slot_id
                    })
                    hourIndex++
                }

                if (daySlot.slots.length > 0) daySlots.push(daySlot);
                dayIndex++
            }

            return daySlots;
        },
        transformTimeRange(timeRange) {
            // Séparer les heures de début et de fin
            const [startTime, endTime] = timeRange.split('-');

            return transformTime(startTime);
        },
        transformTime(time) {
            let [hours, minutes] = time.split(':');
            minutes = minutes.replace('h00', 'h');
            return minutes === '00' ? `${parseInt(hours)}h` : `${parseInt(hours)}h${minutes}`;
        },
        async getAvailableSlots() {

            this.isLoading = true;
            try {
                this.slotsAvailable = [];

                const response = await this.getAvailableAppointments(this.typeAppointment, this.getSelectedStoreCode(), this.csrfToken);

                this.slotsAvailable = this.convertApiResponseToSlots(response.appointments);
            } catch (error) {
                window.displayError(error.responseJSON.message)
                console.error(error);
            } finally {
                this.isLoading = false;
            }
        },
        getAvailableAppointments (type_appointment, store_code, _token) {
            // set default value to in-store
            if (!["in-store", "in-distance", "in-home"].includes(type_appointment)) {
                type_appointment = "in-store";
            }

            let real_time = true;
            let display_full_month = true;

            return $.ajax({
                url: window.API_ROUTES.SLOTS,
                type: 'GET',
                headers: {'X-CSRF-TOKEN': _token},
                data : {_token, type_appointment, store_code},
                beforeSend: startOverlay,
                error: function (error) {
                    stopOverlay();
                    console.error(error)
                },
                complete: stopOverlay
            })
        },
        onCallbackLinkClick() {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
                "event": "custom_click",
                "atEvent": "click.action",
                "click": "se-faire-rappeler",
                "clickChapter1": "espace-perso",
                "category": "espace-perso",
                "action": "click",
                "label": "se-faire-rappeler",
            });

            this.$emit('go-to-step', 'CALLBACK_INFO')
        },
        onStoreChange(e) {
            // à chaque changement, on met à jour la donnée réactive
            this.store = e.target.value;
        },
        async submitForm() {
            this.v$.$touch(); // Valide tous les champs

            if (this.v$.$invalid) {
                console.log('Le formulaire est invalide.');
                return;
            }

            try {
                startOverlay();

                const formData = new FormData();
                formData.append('_token', this.csrfToken);
                formData.append('appointment', 'appointment1');
                formData.append('system_user_id', this.system_user_id);
                formData.append('typeAppointment', this.typeAppointment);
                formData.append('timeslot', this.timeSlot);
                formData.append('civility', this.civility);
                formData.append('firstName', this.firstName);
                formData.append('lastName', this.lastName);
                formData.append('email', this.email);
                formData.append('mobilePhone', this.mobilePhone);
                formData.append('storeCode', this.store);
                formData.append('available_slot_id', this.available_slot_id);
                formData.append('isSmsAllowed', this.isSmsAllowed ? 1 : 0);
                formData.append('isEmailAllowed', this.isEmailAllowed ? 1 : 0);


                const response = await axios.post(this.route, formData, {
                    headers: {
                        'X-CSRF-TOKEN': this.csrfToken,
                    },
                });

                this.$emit('first-name', this.firstName);
                this.$emit('go-to-step', 'APPOINTMENT_CONFIRMED');
                this.$emit('ics-url', response?.data?.ics_url);
                this.addDataLayer(this.typeAppointment);

            } catch (error) {
                window.displayError(error.response?.data.message);
                console.error('Erreur API:', error.response?.data || error.message);

            } finally {
                stopOverlay();
            }
        },
        initNiceScroll() {
            // si déjà instancié, on l’affiche simplement
            if (this.nsInstance) {
                this.nsInstance.show();
                return;
            }

            // sinon on attend le rendu Vue et on instancie
            this.$nextTick(() => {
                const $el = window.jQuery(this.$refs.timeslots);
                this.nsInstance = $el.niceScroll({
                    cursorcolor: "#1d2f4d",
                    cursoropacitymin: 0,
                    cursoropacitymax: 1,
                    cursorwidth: "9px",
                    cursorborderradius: "5px",
                    cursorborder: "1px solid transparent",
                    horizrailenabled: false,
                    zindex: "auto",
                    autohidemode: false,
                    railoffset: { top: 0, left: 20 },
                    railpadding: { top: 2, right: 1, left: 1, bottom: 2 },
                    background: "rgba(29, 47, 77, 0.2)",
                    disablemutationobserver: false    //  cf. pour bloquer les rafraîchissements auto
                });
            });
        },
    }
};
</script>
<style>

</style>
